import React from 'react';
import SpeciesForm from '../SpeciesForm';
import slug from 'constants/slug';
import { create } from 'api/speciesApi';
import Message from 'rc-message';
import PageLockHOC from 'hoc/pageLock';

@PageLockHOC(['biodiversity.write'])
export default class SpeciesCreate extends React.Component {
  static propTypes = {};
  constructor(props) {
    super(props);
    const paramSearch = new URLSearchParams(props.location.search);
    this.biodiversityID = paramSearch.get('biodiversityID');
  }

  handleSubmit = async (values) => {
    const { history } = this.props;

    const params = {
      ...values,
      BiodiversityID: this.biodiversityID,
    };

    const res = await create(params);

    if (res.success) {
      Message.success({ content: 'Thành Công' });
      history.push(
        slug.BIODIVERSITY.DETAIL_WITH_ID +
        this.biodiversityID +
        '/species?speciesID=' +
        res.data._id
      );
    }
    if (res.error) Message.error({ content: res.message });
  };

  render() {
    return <SpeciesForm handleSubmit={this.handleSubmit} />;
  }
}



// WEBPACK FOOTER //
// ./src/containers/Biodiversity/BiodiversityView/SpeciesManagement/SpeciesCreate/index.js